import { render, staticRenderFns } from "./IcoSquare2Plus.vue?vue&type=template&id=5de6861d"
import script from "./IcoSquare2Plus.vue?vue&type=script&lang=js"
export * from "./IcoSquare2Plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports